import React from 'react';

const PengunduranDiri = () => {
  return (
    <h1>Pengunduran Diri</h1>
  );
};

export default PengunduranDiri;





